import { useContext } from 'react';
import {
  BreadcrumbsActionsContext,
  BreadcrumbsActionsContextType,
} from './BreadcrumbsActionsContext';

export type UseBreadcrumbsActions = () => BreadcrumbsActionsContextType;

export const useBreadcrumbsActions: UseBreadcrumbsActions = () => {
  return useContext(BreadcrumbsActionsContext);
};
